import { IClient } from "./Client.model";
import { IFacture } from "./Facture.model";
import { IDetailCommande } from "./DetailCommande.model";
import { IAdresse } from './Adresse.model';

export interface ICommande {
  id?: number;
  numero?: string;
  cocher?: boolean;
  dateLiv?: any;
  dateLivFormat?: string;
  dateLivReel?: any;
  dateCom?: any;
  etat?: string;
  montant?: any;
  avance?: any;
  reduction?: any;
  dayAlert?: any;
  codePromo?: string;
  client?: IClient;
  shippingAddress?: IAdresse;
  factures?: IFacture[];
  details_commandes?: IDetailCommande[];
}

export class Commande implements ICommande {
  constructor(
    public id?: number,
    public numero?: string,
    public dateLiv?: any,
    public dateLivFormat?: string,
    public dateLivReel?: any,
    public dateCom?: any,
    public etat?: string,
    public  dayAlert?: any,
    public cocher?: boolean,
    public montant?: any,
    public avance?: any,
    public reduction?: any,
    public codePromo?: string,
    public client?: IClient,
    public shippingAddress?: IAdresse,
    public factures?: IFacture[],
    public details_commandes?: IDetailCommande[]
  ) {}
}
